/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import env from '../../../env';
import { useGet, SiteLink } from '../../../components';
import { Loading, ErrorPopup } from '../../../components';
import utils from '../../../utils';

/**
 * Purchase history: lists the current user's paid orders (MyOrders).
 * For live-feed items shows a "Watch" button that goes to /watch?t=watchToken.
 */
export function OrderHistoryPage() {
  const get = useGet();

  React.useEffect(() => {
    get.send((env.apiBase || '').replace(/\/$/, '') + '/api/order/MyOrders');
  }, []);

  if (get.loading()) return <Loading />;
  if (get.hasErrors()) return <ErrorPopup title="Error loading orders" errors={get.errors} />;

  const orders = Array.isArray(get.response) ? get.response : [];
  if (orders.length === 0) {
    return (
      <div style={{ padding: '2rem' }}>
        <h2>Purchase history</h2>
        <p>You have no orders yet.</p>
        <SiteLink to="/" className="btn btn-outline-primary">Browse streams</SiteLink>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Purchase history</h2>
      <p className="text-muted">Your paid orders. Use &quot;Watch&quot; to open your stream.</p>
      {orders.map((order) => (
        <div key={order.orderId || order.OrderId} style={{ marginBottom: '1.5rem', padding: '1rem', border: '1px solid #dee2e6', borderRadius: '4px' }}>
          <div style={{ marginBottom: '0.5rem' }}>
            <strong>Order {order.orderNo || order.OrderNo}</strong>
            <span style={{ marginLeft: '1rem', color: '#6c757d' }}>
              {utils.date.formatYYYYMMDD(order.orderDate || order.OrderDate)}
            </span>
            <span style={{ marginLeft: '1rem' }}>
              AU {utils.money.formatMoney(order.totalAmount || order.TotalAmount)}
            </span>
          </div>
          <ul style={{ listStyle: 'none', paddingLeft: 0, marginBottom: 0 }}>
            {(order.orderItems || order.OrderItems || [])
              .filter((item) => Number(item.orderItemType ?? item.OrderItemType ?? 0) === 0)
              .map((item) => {
              const watchToken = item.watchToken || item.WatchToken;
              const name = item.itemName || item.ItemName || 'Item';
              return (
                <li key={item.orderItemId || item.OrderItemId} style={{ padding: '0.25rem 0' }}>
                  {name}
                  {watchToken && (
                    <SiteLink
                      to={`/watch?t=${encodeURIComponent(watchToken)}`}
                      className="btn btn-primary btn-sm"
                      style={{ marginLeft: '0.5rem' }}
                    >
                      Watch
                    </SiteLink>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
}
